import * as tslib_1 from "tslib";
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { UploadService } from '@core/services/upload.service';
import { fileToBase64 } from '@core/utils/file-converter';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as imageCompression from 'browser-image-compression';
import { sentry } from 'sentry';
import { ChangeAvatarService } from './change-avatar.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var ChangeAvatarComponent = /** @class */ (function () {
    function ChangeAvatarComponent(meId, changeAvatarService, imageUploadService, customMessageService, authenticationService, fuseProgressBarService, matDialogRef, fuseTranslationLoaderService) {
        this.meId = meId;
        this.changeAvatarService = changeAvatarService;
        this.imageUploadService = imageUploadService;
        this.customMessageService = customMessageService;
        this.authenticationService = authenticationService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.matDialogRef = matDialogRef;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.isLoading = false;
        this.changeAvatarInput = new FormControl(null, [Validators.required]);
        this.isOnEditDialog = !!(this.meId);
    }
    ChangeAvatarComponent.prototype.saveNewPicture = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var compressedFile, payload, _a, err_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, 8, 9]);
                        this.isLoading = true;
                        this.fuseProgressBarService.show();
                        this.matDialogRef.disableClose = true;
                        return [4 /*yield*/, imageCompression.default(this.selectedPicture, {
                                maxSizeMB: 10,
                                useWebWorker: true
                            })];
                    case 1:
                        compressedFile = _b.sent();
                        _a = {};
                        return [4 /*yield*/, fileToBase64(compressedFile)];
                    case 2:
                        payload = (_a.imageBase64Encoded = _b.sent(),
                            _a.filename = this.changeAvatarInput.value.name,
                            _a.size = this.changeAvatarInput.value.size,
                            _a.path = null,
                            _a);
                        if (!this.isOnEditDialog) return [3 /*break*/, 4];
                        payload.path = "users/" + this.meId;
                        return [4 /*yield*/, this.updateUserAvatar(payload)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.setAvatarToNewUser(payload)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        err_1 = _b.sent();
                        sentry.captureException(err_1);
                        this.customMessageService.error('CHANGE_AVATAR.MESSAGES.CHANGE_AVATAR_ERROR');
                        return [3 /*break*/, 9];
                    case 8:
                        this.isLoading = false;
                        this.fuseProgressBarService.hide();
                        this.matDialogRef.disableClose = false;
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ChangeAvatarComponent.prototype.imageCropped = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.selectedPicture = event.file;
                return [2 /*return*/];
            });
        });
    };
    ChangeAvatarComponent.prototype.addFileToInput = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.changeAvatarInput.reset();
        this.changeAvatarInput.markAsTouched();
        var _a = this.toInputEvent(event), file = _a.file, newEvent = _a.event;
        if (!file || !file.name || !file.size) {
            return;
        }
        var allowedImageExtensions = ['jpg', 'jpeg', 'png', 'jfif', 'heic', 'webp'];
        if (!allowedImageExtensions.includes(file.name.split('.').pop())) {
            this.changeAvatarInput.setErrors({ extension: true });
            return;
        }
        var tenMbInBytes = 1024 * 1024 * 10;
        if (file.size > tenMbInBytes) {
            this.changeAvatarInput.setErrors({ size: true });
            return;
        }
        this.changeAvatarInput.setValue(file);
        this.imageChangedEvent = newEvent;
    };
    ChangeAvatarComponent.prototype.updateUserAvatar = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var avatarUrl;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.imageUploadService.upload(payload)];
                    case 1:
                        avatarUrl = (_a.sent()).path;
                        return [4 /*yield*/, this.changeAvatarService.updateUser({
                                id: this.meId,
                                input: { avatarUrl: avatarUrl }
                            })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.authenticationService.getMe({ updateState: true })];
                    case 3:
                        _a.sent();
                        this.customMessageService.success('CHANGE_AVATAR.MESSAGES.CHANGE_AVATAR_SUCCESS');
                        this.matDialogRef.close({
                            avatarImagePayload: { imageBase64Encoded: avatarUrl }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ChangeAvatarComponent.prototype.setAvatarToNewUser = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.customMessageService.success('CHANGE_AVATAR.MESSAGES.ADD_AVATAR_SUCCESS');
                this.matDialogRef.close({
                    avatarImagePayload: payload
                });
                return [2 /*return*/];
            });
        });
    };
    ChangeAvatarComponent.prototype.toInputEvent = function (event) {
        var sanitizedEvent = event;
        if (event['dataTransfer']) {
            sanitizedEvent.target['files'] = event['dataTransfer'].files;
            delete sanitizedEvent['dataTransfer'];
        }
        return {
            file: sanitizedEvent.target['files'][0],
            event: sanitizedEvent
        };
    };
    return ChangeAvatarComponent;
}());
export { ChangeAvatarComponent };
